<template>
  <div
    :style="{
      position: 'sticky',
      top: '65px',
      zIndex: 4,
      backgroundColor: 'white',
      padding: '0 10px',
    }"
  >
    <v-row>
      <v-col cols="3">
        <v-select
          v-model="selectedRegions"
          :items="regions"
          label="Select Regions"
          outlined
          item-text="name"
          item-value="id"
          multiple
          dense
        >
          <template #selection="{ item, index }">
            <span v-if="index === 0" class="text-truncate">{{ item }}</span>
            <span v-if="index === 1" class="grey--text caption"
              >(+{{ selectedRegions.length - 1 }} others)</span
            >
          </template>
        </v-select>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="selectedFacilities"
          :items="facilities"
          label="Select Facilities"
          multiple
          outlined
          clearable
          item-text="name"
          item-value="id"
          dense
        >
          <template #selection="{ item, index }">
            <span v-if="index === 0" class="text-truncate">{{
              item.name
            }}</span>
            <span v-if="index === 1" class="grey--text caption"
              >(+{{ selectedFacilities.length - 1 }} others)</span
            >
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="3" />
      <v-col cols="3">
        <v-select
          v-model="dashboard"
          :items="dashboards"
          label="Select Dashboard"
          outlined
          item-text="name"
          item-value="id"
          dense
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
  data() {
    return {
      selectedRegions: ["Three by Three Storage"],
      regions: ["Three by Three Storage", "Region 2", "Region 3"],
      dashboards: [
        { id: 1, name: "Management Summary" },
        { id: 2, name: "Monitoring & Control Hub" },
        { id: 3, name: "Operations Summary" },
      ],
      dashboard: 3,
      selectedFacilities: [
        { id: 1, name: "3x3 Self Storage - Denton" },
        { id: 2, name: "3x3 Self Storage - Fort Worth" },
        { id: 3, name: "3x3 Self Storage - Waco" },
      ],
      facilities: [
        { id: 1, name: "3x3 Self Storage - Denton" },
        { id: 2, name: "3x3 Self Storage - Fort Worth" },
        { id: 3, name: "3x3 Self Storage - Waco" },
      ],
    };
  },
  watch: {
    dashboard(newDashboard) {
      if (newDashboard === 1) {
        this.$router.push({ path: "/demo/management" });
      }
      if (newDashboard === 2) {
        this.$router.push({ path: "/demo/call-center" });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
